import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { catchError, withLatestFrom, mergeMap } from 'rxjs/operators';
import { DEFERRAL_DATE_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import { getBillingBalanceRequest } from '../actions/billing-balance.actions';
import { getBillingTransactionsRequest } from '../actions/billing-transactions.actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';
import { RemoteLoggerService } from 'src/app/my-bill/services/remote-logger.service';
import {
  deferralFailure,
  deferralRequest,
  deferralSuccess,
} from '../actions/deferral.actions';

@Injectable()
export class DeferralEffects {
  deferralAcceptNewDate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deferralRequest),
      withLatestFrom(this.store.select(selectCustomer)),
      mergeMap(([{ paNumber, invoiceReference, requestBody }, customer]) => {
        const parameters = {
          paNumber,
          invoiceReference,
          cdbid: customer.customerId,
        };
        return EntityManager.saveEntity<{}>({
          ...EntityManager.createEntity(DEFERRAL_DATE_ENTITY, parameters),
          value: requestBody,
        }).pipe(
          mergeMap((updateEntity) => {
            const outActions = [];
            outActions.push(deferralSuccess());
            outActions.push(getBillingBalanceRequest());
            outActions.push(getBillingTransactionsRequest(paNumber));
            return outActions;
          }),
          catchError((error) => {
            this.remoteLoggerService.logErrorImmediately(
              'update deferral call failed',
              error
            );
            return of(deferralFailure());
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>,
    private remoteLoggerService: RemoteLoggerService
  ) {}
}
